/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Stack, Text, TextField, ActionButton, Depths } from '@fluentui/react';

export default function DebugContractAdditionalDetails({ data }) {
  const { productGuids, stagedTransactionsBreakdown } = data;
  const [showDetails, setShowDetails] = useState(false);

  return (
    <Stack horizontalAlign="start" tokens={{ childrenGap: 14 }}>
      <ActionButton onClick={() => setShowDetails(prevVal => !prevVal)}>
        {!showDetails ? 'Show Additional Details' : 'Hide Additional Details'}
      </ActionButton>
      {showDetails && (
        <span>
          <Stack
            tokens={{ childrenGap: 8 }}
            style={{
              display: 'inline-flex',
              backgroundColor: 'white',
              boxShadow: Depths.depth4,
              padding: 20,
              marginRight: 20,
            }}
          >
            <Text>Contract Product Mapping</Text>

            <Text style={{ fontWeight: 'normal' }}>
              This is a list of product guids associated with this contract as found in the
              Royalties Cloud Store
            </Text>
            <Stack>
              <TextField multiline value={productGuids.map(guid => `"${guid}"`).join(',\n')} />
              {/* {productGuids.map(productGuid => (
                <Text style={{ fontWeight: 'normal' }}>{productGuid}</Text>
              ))} */}
            </Stack>
          </Stack>

          <Stack
            tokens={{ childrenGap: 8 }}
            style={{
              display: 'inline-flex',
              backgroundColor: 'white',
              boxShadow: Depths.depth4,
              padding: 20,
              marginRight: 20,
            }}
          >
            <Text>Staged Transactions</Text>
            <Stack horizontal tokens={{ childrenGap: 8 }}>
              <Text>Total Count</Text>
              <Text>{stagedTransactionsBreakdown.totalTransactions}</Text>
            </Stack>
          </Stack>
        </span>
      )}

      <div style={{ width: 140, height: 140, position: 'relative' }}>
        <iframe
          sandbox
          src="https://giphy.com/embed/Wn74RUT0vjnoU98Hnt"
          style={{ position: 'absolute', width: '100%', height: '100%' }}
          frameBorder="0"
          className="giphy-embed"
          allowFullScreen
          title="grogu gif"
        />
      </div>
    </Stack>
  );
}

DebugContractAdditionalDetails.propTypes = {
  data: PropTypes.shape({}).isRequired,
};
